<template>
  <div class="basic">
    <van-collapse v-model="activeNames">
      <!-- <van-button class="btnThree" @click="$router.push('/addWork')"
        ><van-icon name="add-o" style="margin-right: 6px" />添加</van-button
      > -->
      <van-collapse-item
        class="box"
        v-for="(item, ind) in euBgworkexpList"
        :key="item.id"
        :title="item.organization"
        :name="ind"
        :border="false"
      >
        <van-cell-group>
          <van-field
            label-width="80"
            input-align="right"
            v-model="item.empno"
            label="工号"
            :readonly="item.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            label-width="80"
            input-align="right"
            v-model="item.begindate"
            label="开始时间"
            :readonly="item.readonly"
            v-if="item.readonly === true"
          />
          <van-field
            label-width="80"
            input-align="right"
            type="date"
            @change="setStateTime"
            v-model="item.begindate"
            label="开始时间"
            v-else
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            label-width="80"
            input-align="right"
            v-model="item.enddate"
            label="结束时间"
            :readonly="item.readonly"
            v-if="item.readonly === true"
          />
          <van-field
            label-width="80"
            input-align="right"
            type="date"
            @change="setEndTime"
            v-model="item.enddate"
            label="结束时间"
            v-else
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            label-width="80"
            type="textarea"
            autosize
            rows="1"
            input-align="right"
            v-model="item.workcity"
            label="工作城市"
            :readonly="item.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            label-width="80"
            input-align="right"
            v-model="item.organization"
            label="公司名称"
            :readonly="item.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            label-width="80"
            input-align="right"
            v-model="item.position"
            label="岗位名称"
            :readonly="item.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            label-width="80"
            type="textarea"
            :autosize="{ maxHeight: 120, minHeight: 20 }"
            rows="1"
            input-align="right"
            v-model="item.duty"
            label="主要职责"
            :readonly="item.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <!-- <div class="edit">
            <van-button
              round
              class="btn"
              @click="workRead(item.id)"
              v-if="item.readonly === true"
              ><van-icon
                name="edit"
                style="margin-right: 6px"
              />修改</van-button
            >
          </div>
          <div class="add">
            <van-button
              round
              class="btnTwo"
              @click="workReset(item.id)"
              v-if="item.readonly === false"
              >取消</van-button
            >
            <van-button
              round
              class="btnTwo"
              type="info"
              @click="workQuery(item.id)"
              v-if="item.readonly === false"
              >确定</van-button
            >
          </div> -->
        </van-cell-group>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import api from "@/apis";
import moment from "moment";
import { getToken } from "@/utils/cookie";
export default {
  name: "basic",
  props: ["toFrom"],
  data() {
    return {
      tagList: [],
      activeNames: [],
      euBgworkexpList: [],
      euBgworkexpListData: {},
    };
  },
  mounted() {
    this.getList();
    const type = this.$route.query.type;
    setTimeout(() => {
      if (this.toFrom.name === "addWork" && type === "add") {
        const lang = this.euBgworkexpList.length - 1;
        this.activeNames = [lang];
      } else {
        this.activeNames = [0];
      }
    }, 1000);
  },
  methods: {
    saveList(obj) {
      api.setSaveEmpInfo(obj).then(() => {
        this.getList();
      });
    },
    //点击修改
    workRead(id) {
      const index = this.euBgworkexpList.find((item) => {
        return item.id === id;
      });
      index.readonly = false;
      this.euBgworkexpListData = index;
    },
    //点击取消
    workReset(id) {
      const index = this.euBgworkexpList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      this.getList();
    },
    //点击确定
    workQuery(id) {
      const index = this.euBgworkexpList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      let obj = {
        ...index,
        table: "euBgworkexpList",
        saveType: "2",
        readonly: true,
        id: index.id,
        empno: index.empno,
        empid: index.empid,
      };
      this.saveList(obj);
    },
    //获取数据列表
    getList() {
      api.getSelectByEmpNo({ empNo: getToken() }).then((data) => {
        this.tagList = data.data;
        this.euBgworkexpList = this.tagList.euBgworkexpList;
        this.euBgworkexpList.forEach((item) => {
          item.begindate =
            item.begindate && moment(item.begindate).format("YYYY-MM-DD");
          item.enddate =
            item.enddate && moment(item.enddate).format("YYYY-MM-DD");
        });
      });
    },
    //参与时间不能大于结束时间
    setStateTime() {
      if (
        this.euBgworkexpListData.begindate > this.euBgworkexpListData.enddate &&
        this.euBgworkexpListData.enddate
      ) {
        this.$toast("参与时间不能大于结束时间");
        this.euBgworkexpListData.begindate = "";
      }
    },
    //结束时间不能小于开始时间
    setEndTime() {
      if (
        this.euBgworkexpListData.enddate < this.euBgworkexpListData.begindate
      ) {
        this.$toast("结束时间不能小于开始时间");
        this.euBgworkexpListData.enddate = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.basic {
  .van-collapse-item {
    margin-top: 5px * $zoom;
    background: none;
  }
  ::v-deep .van-cell__title span {
    font-size: 12px * $zoom;
    border-left: 6px solid #018755;
    padding-left: 15px;
  }
  ::v-deep .van-field {
    span {
      font-size: 10px * $zoom;
      border: none;
      padding-left: 0;
    }
  }
  ::v-deep .van-cell {
    display: flex;
    justify-content: space-between;
    border-radius: 15px;
  }
  ::v-deep .van-collapse-item__content {
    background: none;
    padding: 12px 0 0 0;
  }
  .conTitle {
    background: #fff;
  }
}
.edit {
  width: 100%;
  display: flex;
  justify-content: center;
}
.btn {
  font-size: 12pt;
  padding: 10px * $zoom 40px * $zoom;
  margin: 10px * $zoom 0;
}
.add {
  width: 100%;
  display: flex;
  justify-content: center;
  .van-button__content {
    width: 80pt;
  }
}
.btnTwo {
  font-size: 12pt;
  // padding: 20px * $zoom 50px * $zoom;
  margin: 10px * $zoom 0 10px * $zoom 10px * $zoom;
}
.btnThree {
  margin-top: 5px * $zoom;
  font-size: 14pt;
  width: 100%;
  height: 40px * $zoom;
}
</style>
